<section [ngClass]="{ 'stack-trace': stackTrace !== undefined, confirm: true }">
  <div class="header">
    <div class="left-part">
      <mat-icon [color]="'warn'" class="error-icon">error</mat-icon>
      <span class="ml-12">{{ 'ERROR' | translate }}</span>
    </div>
    <button tabindex="-1" disableRipple mat-icon-button>
      <mat-icon class="close-button" (click)="close()">close</mat-icon>
    </button>
  </div>
  <div class="body">
    <span class="message">{{ message | translate : messageVars }}</span>
    <pre *ngIf="stackTrace !== undefined">
      <code
        [lineNumbers]="true"
        [languages]="['json']"
        [matTooltipPosition]="'above'"
        [matTooltipShowDelay]="1000"
        [matTooltip]="'ONLY_TEST_MODE_INFO' | translate"
        [highlight]="'//stack-trace\n' +stackTrace">
      </code>
    </pre>
    <div class="extra-text" *ngIf="extraText">
      {{ extraText | translate }}
    </div>
    <div class="extra-text-list" *ngIf="extraTextList">
      <ul>
        <li *ngFor="let item of extraTextList">{{ item | translate }}</li>
      </ul>
    </div>
  </div>
  <div class="footer">
    <button [autofocus]="false" mat-button (click)="close()">{{ 'CLOSE' | translate }}</button>
  </div>
</section>
